import * as angular from 'angular';

import { ComponentDefinition } from '../../models/index';

class EnableZoomController implements angular.IComponentController {
    isLoading: boolean;
    item: any;
    loadingMessage: string;

    static $inject = [];
}

export const wtEnableZoom: ComponentDefinition = {
    componentId: 'wtEnableZoom',
    controller: EnableZoomController,
    template: require('./enableZoom.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '='
    }
};
